import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { PersonProduct, ProductStatusUpdate } from './types';

export const pushTopicToNaturalLanguage = (topic: string, teams: any): string => {
  let type = '';
  let replaceType = '';

  if (topic.includes('TEAM_EVENTS')) {
    type = 'Matchhändelser: ';
    replaceType = 'TEAM_EVENTS_';
  }
  if (topic.includes('TEAM_EVENTS') && topic.includes('HIGHLIGHTS_PLUS')) {
    type = 'Matchhändelser H+: ';
    replaceType = 'TEAM_EVENTS_';
  }
  if (topic.includes('TEAM_NEWS')) {
    type = 'Lagnyheter: ';
    replaceType = 'TEAM_NEWS_';
  }
  if (topic.includes('LEAGUE_NEWS')) {
    type = 'Lagnyheter: ';
    replaceType = '_LEAGUE_NEWS';
  }

  const teamIdFromTopics = topic
    .replace(replaceType, '')
    .replace('_', '')
    .replace('HIGHLIGHTS_PLUS', '');

  const team = teams.find(
    (team: any) =>
      String(team.everySportId) === String(teamIdFromTopics) || team.abbrv === teamIdFromTopics
  );

  if (teamIdFromTopics === 'allsvenskan') {
    return `${type} Allsvenskan`;
  }

  if (teamIdFromTopics === 'superettan') {
    return `${type} Superettan`;
  }
  return `${type} ${team.name}`;
};

const appMapping = [
  {
    appName: 'Allsvenskan Live (officiell)',
    packageName: {
      android: 'se.allsvenskan.android',
      ios: 'com.sportomedia.allsvenskan2012',
    },
    appShortName: 'ALLSVENSKAN',
    everySportId: undefined,
  },
  {
    appName: 'Superettan Live (officiell)',
    packageName: {
      android: 'se.superettan.android',
      ios: 'com.sportomedia.superettan2012',
    },
    appShortName: 'SUPERETTAN',
    everySportId: undefined,
  },
  {
    appName: 'SFL Live',
    packageName: {
      android: 'com.connectedleague.futsal',
      ios: 'com.connectedleague.futsal',
    },
    appShortName: 'FUTSAL',
    everySportId: undefined,
  },
  {
    appName: 'OBOS Damallsvenskan',
    packageName: {
      android: 'com.connectedleague.obosdamallsvenskan',
      ios: 'com.connectedleague.obosdamallsvenskan',
    },
    appShortName: 'DAMALLSVENSKAN',
    everySportId: undefined,
  },
  {
    appName: 'AIK Live',
    packageName: {
      android: 'com.connectedleague.club.aik',
      ios: 'com.connectedleague.club.aik',
    },
    appShortName: 'AIK',
    everySportId: '9367',
  },
  {
    appName: 'AFC Live',
    packageName: {
      android: 'com.connectedleague.club.afc',
      ios: 'com.connectedleague.club.afc',
    },
    appShortName: 'AFC',
    everySportId: '155037',
  },
  {
    appName: 'BK Häcken Live',
    packageName: {
      android: 'com.connectedleague.club.hacken',
      ios: 'com.connectedleague.club.hacken',
    },
    appShortName: 'BKH',
    everySportId: '19740',
  },
  {
    appName: 'Hammarby Fotboll Live',
    packageName: {
      android: 'com.connectedleague.club.hammarby',
      ios: 'com.app.p4123FI',
    },
    appShortName: 'HAM',
    everySportId: '9372',
  },
  {
    appName: 'DIF Fotboll Live',
    packageName: {
      android: 'com.connectedleague.club.dif',
      ios: 'com.connectedleague.club.dif',
    },
    appShortName: 'DIF',
    everySportId: '9368',
  },
  {
    appName: 'GIF Sundsvall Live',
    packageName: {
      android: 'com.connectedleague.club.gif',
      ios: 'com.connectedleague.club.gif',
    },
    appShortName: 'SUN',
    everySportId: '9407',
  },
  {
    appName: 'HBK Fotboll Live',
    packageName: {
      android: 'com.connectedleague.club.hbk',
      ios: 'com.connectedleague.club.hbk',
    },
    appShortName: 'HBK',
    everySportId: '9371',
  },
  {
    appName: 'IF Elfsborg Live',
    packageName: {
      android: 'com.connectedleague.club.elfsborg',
      ios: 'com.connectedleague.club.elfsborg',
    },
    appShortName: 'IFE',
    everySportId: '9369',
  },
  {
    appName: 'IFK Göteborg Live',
    packageName: {
      android: 'com.connectedleague.club.ifkgoteborg',
      ios: 'com.connectedleague.club.ifkgoteborgfotboll',
    },
    appShortName: 'GBG',
    everySportId: '9370',
  },
  {
    appName: 'IK Frej Täby Live',
    packageName: {
      android: 'com.connectedleague.club.ikfrej',
      ios: 'com.connectedleague.club.ikfrej',
    },
    appShortName: 'IKF',
    everySportId: '10078',
  },
  {
    appName: 'IFK Norrköping Live',
    packageName: {
      android: 'com.connectedleague.club.ifknorrkoping',
      ios: 'com.connectedleague.club.ifknorrkoping',
    },
    appShortName: 'NOR',
    everySportId: '9376',
  },
  {
    appName: 'Sirius Live',
    packageName: {
      android: 'com.connectedleague.club.sirius',
      ios: 'com.connectedleague.club.sirius',
    },
    appShortName: 'IKS',
    everySportId: '9404',
  },
  {
    appName: 'Jönköpings Södra Live',
    packageName: {
      android: 'com.connectedleague.club.jonkoping',
      ios: 'com.connectedleague.club.jonkoping',
    },
    appShortName: 'JON',
    everySportId: '9595',
  },
  {
    appName: 'Kalmar FF Live',
    packageName: {
      android: 'com.connectedleague.club.kalmar',
      ios: 'com.connectedleague.club.kalmar',
    },
    appShortName: 'KFF',
    everySportId: '9374',
  },
  {
    appName: 'MFF Live',
    packageName: {
      android: 'com.connectedleague.club.mff',
      ios: 'com.connectedleague.club.mff',
    },
    appShortName: 'MFF',
    everySportId: '9375',
  },
  {
    appName: 'ÖSK Live',
    packageName: {
      android: 'com.connectedleague.club.osk',
      ios: 'com.connectedleague.club.osk',
    },
    appShortName: 'OSK',
    everySportId: '9379',
  },
  {
    appName: 'Östersunds FK Live',
    packageName: {
      android: 'com.connectedleague.club.ostersund',
      ios: 'com.connectedleague.club.ostersund',
    },
    appShortName: 'OFK',
    everySportId: '9422',
  },
  {
    appName: 'Falkenbergs FF Live',
    packageName: {
      android: 'com.connectedleague.club.fff',
      ios: 'com.connectedleague.club.fff',
    },
    appShortName: 'FFF',
    everySportId: '9381',
  },
  {
    appName: 'HIF Live',
    packageName: {
      android: 'com.connectedleague.club.hif',
      ios: 'com.connectedleague.club.hif',
    },
    appShortName: 'HIF',
    everySportId: '9373',
  },
  {
    appName: 'Landskrona BoIS Live',
    packageName: {
      android: 'com.connectedleague.club.landskrona',
      ios: 'com.connectedleague.club.landskrona',
    },
    appShortName: 'LAN',
    everySportId: '9388',
  },
  {
    appName: 'Gefle IF Live',
    packageName: {
      android: 'com.connectedleague.club.gefle',
      ios: 'com.connectedleague.club.gefle',
    },
    appShortName: 'GIF',
    everySportId: '9400',
  },
  {
    appName: 'BP Live',
    packageName: {
      android: 'com.connectedleague.club.bp',
      ios: 'com.connectedleague.club.bp',
    },
    appShortName: 'IFBP',
    everySportId: '19721',
  },
  {
    appName: 'Östers IF Live',
    packageName: {
      android: 'com.connectedleague.club.osters',
      ios: 'com.connectedleague.club.osters',
    },
    appShortName: 'OIF',
    everySportId: '9394',
  },
  {
    appName: 'Dalkurd Live',
    packageName: {
      android: 'com.connectedleague.club.dalkurd',
      ios: 'com.connectedleague.club.dalkurd',
    },
    appShortName: 'DFF',
    everySportId: '25458',
  },
  {
    appName: 'Norrby IF Live',
    packageName: {
      android: 'com.connectedleague.club.norrbyif',
      ios: 'com.connectedleague.club.norrbyif',
    },
    appShortName: 'NIF',
    everySportId: '9450',
  },
  {
    appName: 'IFK Värnamo Live',
    packageName: {
      android: 'com.connectedleague.club.varnamo',
      ios: 'com.connectedleague.club.varnamo',
    },
    appShortName: 'VARN',
    everySportId: '9604',
  },
  {
    appName: 'ÖIS Fotboll Live',
    packageName: {
      android: 'com.connectedleague.club.ois',
      ios: 'com.connectedleague.club.ois',
    },
    appShortName: 'OIS',
    everySportId: '9380',
  },
  {
    appName: 'ÅFF Live',
    packageName: {
      android: 'com.connectedleague.club.aff',
      ios: 'com.connectedleague.club.aff',
    },
    appShortName: 'AFF',
    everySportId: '9393',
  },
  {
    appName: 'TFF Live',
    packageName: {
      android: 'com.connectedleague.club.tff',
      ios: 'com.connectedleague.club.tff',
    },
    appShortName: 'TFF',
    everySportId: '9377',
  },
  {
    appName: 'GAIS Live',
    packageName: {
      android: 'com.connectedleague.club.gais',
      ios: 'com.connectedleague.club.gais',
    },
    appShortName: 'GAIS',
    everySportId: '9382',
  },
  {
    appName: 'Varbergs BoIS Live',
    packageName: {
      android: 'com.connectedleague.club.bois',
      ios: 'com.connectedleague.club.varbergbois',
    },
    appShortName: 'VAR',
    everySportId: '9601',
  },
  {
    appName: 'Degerfors IF Live',
    packageName: {
      android: 'com.connectedleague.club.degerfors',
      ios: 'com.connectedleague.club.degerfors',
    },
    appShortName: 'DEIF',
    everySportId: '24380',
  },
  {
    appName: 'IK Brage Live',
    packageName: {
      android: 'com.connectedleague.club.brage',
      ios: 'com.connectedleague.club.brage',
    },
    appShortName: 'IKB',
    everySportId: '9396',
  },
  {
    appName: 'VSK Live',
    packageName: {
      android: 'com.connectedleague.club.vasteras',
      ios: 'com.connectedleague.club.vasteras.sk',
    },
    appShortName: 'VSK',
    everySportId: '9409',
  },
  {
    appName: 'Ljungskile SK Live',
    packageName: {
      android: 'com.connectedleague.club.ljungskile',
      ios: 'com.connectedleague.club.ljungskile.sk',
    },
    appShortName: 'LJUN',
    everySportId: '9391',
  },
  {
    appName: 'Mjällby AIF Live',
    packageName: {
      android: 'com.connectedleague.club.mjallby',
      ios: 'com.connectedleague.club.mjallby',
    },
    appShortName: 'MAIF',
    everySportId: '9389',
  },
  {
    appName: 'Umeå FC Live',
    packageName: {
      android: 'com.connectedleague.club.umea',
      ios: 'com.connectedleague.club.umea.fc',
    },
    appShortName: 'UME',
    everySportId: '9408',
  },
  {
    appName: 'SEF League Test',
    packageName: {
      android: 'com.connectedleague.league.unibetleaguetest',
      ios: 'com.connectedleague.league.unibetleaguetest',
    },
    appShortName: 'ALLSVENSKAN',
    everySportId: undefined,
  },
  {
    appName: 'SEF Club Test',
    packageName: {
      android: 'com.connectedleague.club.sefclubtest',
      ios: 'com.connectedleague.club.sefclubtest',
    },
    appShortName: 'HAM',
    everySportId: '9372',
  },
  {
    appName: 'Skövde AIK Live',
    packageName: {
      android: 'com.connectedleague.club.skovdeaik',
      ios: 'com.connectedleague.club.skovdeaik',
    },
    appShortName: 'SKAIK',
    everySportId: '9455',
  },
  {
    appName: 'Utsiktens BK Live',
    packageName: {
      android: 'com.connectedleague.club.utsikten',
      ios: 'com.connectedleague.club.utsikten',
    },
    appShortName: 'UBK',
    everySportId: '11297',
  },
];

export const getAppNameFromPackageName = (packageName: string): string => {
  const packageNameParsed = packageName.replaceAll('-', '.');
  const app = appMapping.find(
    (app) =>
      app.packageName.android === packageNameParsed || app.packageName.ios === packageNameParsed
  );

  return app?.appName?.replace('(officiell)', '') || packageName;
};

export const useWebhookEventsProducts = (events: any) => {
  const [webhookEvents, setWebhookEvents] = React.useState<any[]>([]);
  React.useEffect(() => {
    if (events) {
      const parsedEvents = events.map((event: any) => {
        return {
          received: moment(event.Received).format('YYYY-MM-DD HH:mm'),
          status: event.Status,
          updatedAt: moment(event.UpdatedAt).format('YYYY-MM-DD HH:mm'),
          productId: event.ProductId,
        };
      });

      setWebhookEvents(_.orderBy(parsedEvents, 'received', 'desc'));
    }
  }, [events]);

  return {
    webhookEvents,
  };
};

export type Products = {
  key: string;
  productName: string;
  changedAt: string;
  status: string;
  start?: string;
  accessUntil?: string;
  type: 'OneTime' | 'Recurring';
};

export const useProducts = (userProducts?: ProductStatusUpdate[]) => {
  const [products, setProducts] = React.useState<Products[]>([]);

  React.useEffect(() => {
    if (userProducts) {
      const subscriptions = Object.entries(userProducts)
        .filter(([_, p]) => p.BillingType === 'OneTime')
        .map(([pId, p]) => {
          return {
            key: pId,
            productName: p.ProductName || '',
            changedAt: moment(p.ChangedAt).format('YYYY-MM-DD HH:mm'),
            status: p.Status || '',
            type: p.BillingType,
          } satisfies Products;
        })
        .sort((a, b) => moment(b.changedAt).diff(moment(a.changedAt)));
      setProducts(subscriptions);
    }
  }, [userProducts]);

  return {
    products,
  };
};

export const useSubscriptions = (userProducts?: ProductStatusUpdate[]) => {
  const [subscriptions, setSubscriptions] = React.useState<Products[]>([]);

  React.useEffect(() => {
    if (userProducts) {
      const subscriptions = Object.entries(userProducts)
        .filter(([_, p]) => p.BillingType === 'Recurring' || p.ProductName === 'Highlights Plus')
        .map(([pId, p]) => {
          return {
            key: pId,
            productName:
              p.ProductName === 'Highlights Plus'
                ? p.ProductName + ' (gamla)'
                : p.ProductName || '',
            start: moment(p.Start).format('YYYY-MM-DD HH:mm'),
            accessUntil: moment(p.HasAccessUntil).format('YYYY-MM-DD HH:mm'),
            changedAt: moment(p.ChangedAt).format('YYYY-MM-DD HH:mm'),
            status: p.Status || '',
            type: p.BillingType,
          } satisfies Products;
        })
        .sort((a, b) => moment(b.changedAt).diff(moment(a.changedAt)));
      setSubscriptions(subscriptions);
    }
  }, [userProducts]);

  return {
    subscriptions,
  };
};

export type SubscriptionFromCee = {
  key: string;
  productName: string;
  start: string;
  accessUntil: string;
  status: 'Active' | 'Inactive' | 'Cancelled';
};

export const useSubscriptionsFromCee = (ceeProducts: PersonProduct[] | null) => {
  const [ceeSubscriptions, setCeeSubscriptions] = React.useState<SubscriptionFromCee[]>([]);

  React.useEffect(() => {
    if (ceeProducts) {
      const filteredProducts = ceeProducts.filter(
        (product) => product.Product.BillingType === 'Recurring'
      );

      const subscriptions = filteredProducts
        .map((p) => {
          return {
            key: p.OrderId,
            productName: p.Product.DisplayName,
            start: moment(p.SubscriptionStartDate).format('YYYY-MM-DD HH:mm'),
            accessUntil: moment(p.SubscriptionNextRenewalDate).format('YYYY-MM-DD HH:mm'),
            status: p.Status,
          } satisfies SubscriptionFromCee;
        })
        .sort((a, b) => moment(b.start).diff(moment(a.start)));

      setCeeSubscriptions(subscriptions);
    }
  }, [ceeProducts]);

  return {
    ceeSubscriptions,
  };
};
